import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import { SVGProps } from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const QuestionIcon: React.FC<IconProps & SVGProps<SVGSVGElement>> = ({
  color = "#fd6a65",
  withBackground,
  ...rest
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g transform="translate(6 6)" fill={color}>
            <circle
              fillRule="nonzero"
              opacity=".12"
              cx="10"
              cy="10"
              r="9.231"
            />
            <path d="M10 1.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm11.026 4.103a1.026 1.026 0 1 1-2.052 0 1.026 1.026 0 0 1 2.052 0ZM8.718 7.949a1.282 1.282 0 1 1 2.564 0v.124c0 .373-.148.73-.412.995l-1.414 1.414a.77.77 0 1 0 1.088 1.088l1.414-1.414a2.945 2.945 0 0 0 .863-2.083V7.95a2.82 2.82 0 1 0-5.642 0v.513a.77.77 0 0 0 1.539 0v-.513Z" />
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
